import { styled, notDesktop } from '@obvio/app'
import { Grid } from '@obvio/ui'

export const GridSubmit = styled(Grid)`
  > div:last-child {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  @media ${notDesktop} {
    grid-template-columns: 1fr;
  }
`
